import { ReactNode } from "react";
import { Trans } from "@lingui/macro";
import { LanguageSwitcher } from "./LanguageSwitcher";
import { AppearanceMenu } from "@/components/AppearanceMenu";

interface AuthShellProps {
  children: ReactNode;
}

export function AuthShell({ children }: AuthShellProps) {
  const year = new Date().getFullYear();

  return (
    <div className="relative min-h-screen w-full bg-background overflow-hidden">
      {/* Soft radial tint using primary color — automatic light/dark adaptation via CSS vars */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top,hsl(var(--primary)/0.12),transparent_60%)]"
      />

      <div className="absolute top-4 right-4 flex items-center gap-2 z-10">
        <LanguageSwitcher />
        <AppearanceMenu />
      </div>

      <main className="relative z-0 min-h-screen flex items-center justify-center px-4">
        {children}
      </main>

      <footer className="absolute bottom-4 left-0 right-0 text-center text-xs text-muted-foreground">
        <Trans id="auth.footer.copyright">© {year} Daycare Butler</Trans>
      </footer>
    </div>
  );
}
